import { useSelector } from "react-redux";
import { RootState } from "reducer";

export const useFarms = () => {
  return useSelector((state: RootState) => state.post);
};